import React from "react";
import Slider from "react-slick";
import { Link } from "react-router-dom";
import bannerImg1 from "../../../assets/images/home_page_4/banner/01.png";
import bannerImg2 from "../../../assets/images/home_page_4/banner/02.png";
import bannerImg3 from "../../../assets/images/home_page_4/banner/03.png";
import bannerImg4 from "../../../assets/images/home_page_4/banner/04.png";

const settings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 3000,
    arrows: true,
};


const HomeBanner = () => {


    return (
        <>
            <section id="home-banner" className="home-banner-main-block">
                <div className="container">
                    <div className="row">
                        <div className="col-lg-8">
                            <Slider {...settings} className="home-slider-autoplay">
                                <div className="home-banner-block">
                                    <div className="row align-items-center">
                                        <div className="col-lg-7 col-md-6">
                                            <div className="home-banner-dtl">
                                                <h4 className="home-banner-sub-heading">
                                                    Exclusive Offer <span className="home-badge">-20% Off</span>
                                                </h4>
                                                <h1 className="home-banner-heading">Super Fast Performance</h1>
                                                <p>
                                                    We have prepared special discounts for you on electronic products.
                                                    Don't miss these opportunities...
                                                </p>
                                                <Link to="#" className="btn btn-primary">
                                                    Shop Now <i className="flaticon-right-arrows" />
                                                </Link>
                                            </div>
                                        </div>
                                        <div className="col-lg-5 col-md-6">
                                            <div className="home-banner-img">
                                                <Link to="#">
                                                    <img src={bannerImg1} className="img-fluid" alt="Banner 1" />
                                                </Link>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div className="home-banner-block">
                                    <div className="row align-items-center">
                                        <div className="col-lg-7 col-md-6">
                                            <div className="home-banner-dtl">
                                                <h4 className="home-banner-sub-heading">
                                                    Exclusive Offer <span className="home-badge">-20% Off</span>
                                                </h4>
                                                <h1 className="home-banner-heading">Super Fast Performance</h1>
                                                <p>
                                                    We have prepared special discounts for you on electronic products.
                                                    Don't miss these opportunities...
                                                </p>
                                                <Link to="#" className="btn btn-primary">
                                                    Shop Now <i className="flaticon-right-arrows" />
                                                </Link>
                                            </div>
                                        </div>
                                        <div className="col-lg-5 col-md-6">
                                            <div className="home-banner-img">
                                                <Link to="#">
                                                    <img src={bannerImg3} className="img-fluid" alt="Banner 3" />
                                                </Link>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div className="home-banner-block">
                                    <div className="row align-items-center">
                                        <div className="col-lg-7 col-md-6">
                                            <div className="home-banner-dtl">
                                                <h4 className="home-banner-sub-heading">
                                                    Exclusive Offer <span className="home-badge">-20% Off</span>
                                                </h4>
                                                <h1 className="home-banner-heading">Super Fast Performance</h1>
                                                <p>
                                                    We have prepared special discounts for you on electronic products.
                                                    Don't miss these opportunities...
                                                </p>
                                                <Link to="#" className="btn btn-primary">
                                                    Shop Now <i className="flaticon-right-arrows" />
                                                </Link>
                                            </div>
                                        </div>
                                        <div className="col-lg-5 col-md-6">
                                            <div className="home-banner-img">
                                                <Link to="#">
                                                    <img src={bannerImg4} className="img-fluid" alt="Banner 4" />
                                                </Link>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </Slider>
                        </div>

                        <div className="col-lg-4">
                            <div className="home-banner-block home-banner-block-two">
                                <div className="home-banner-img">
                                    <Link to="#">
                                        <img src={bannerImg2} className="img-fluid" alt="Banner 2" />
                                    </Link>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </>
    );
};

export default HomeBanner;
